import { NgModule } from 'angular-ts-decorators';

import { CompareCheckboxComponent } from './compare-checkbox/compare-checkbox.component';
import { AnchorBarItemDirective } from './directives/anchor-bar-item.directive';
import { AnchorBarDirective } from './directives/anchor-bar.directive';

import { AnchorBarService, CompareCheckboxService } from './services';

@NgModule({
  declarations: [
    AnchorBarDirective,
    AnchorBarItemDirective,
    CompareCheckboxComponent,
  ],
  id: 'gn.audio.public.design',
  imports: [],
  providers: [
    AnchorBarService,
    CompareCheckboxService
  ],
})
export class DesignModule {
}
